import React , { Component, Fragment } from 'react'
import AttendanceTable from './AttendaceTable'
import { Input , Form, Row,Col} from 'antd'
import AddAttendance from './AddAttendance'



class Attendance extends Component{


    state = {
        loading : false
    }

    setLoading = (value) => {
        this.setState(
            {loading:value}
        )
    }



    render(){
        return( 
        <Fragment>
            <AddAttendance setLoading = {this.setLoading}/>
            <AttendanceTable loading={this.state.loading}/>
        </Fragment>
        )
    }

}

export default Attendance